module.exports = __webpack_public_path__ + "img/contract_bg.2e5ba81a.png";